<template>
  <el-card>
    <div slot="header">
      <div class="page-hedaer">
        <h4 class="page-title">用户列表</h4>
        <span class="title-info">(显示系统全部用户信息)</span>
      </div>
    </div>
    <div class="search-bar">
      <el-input
        v-model="keyword"
        placeholder="搜索手机号"
        clearable
        class="search-input"
        @keyup.enter.native="handleSearch"
        size="small"
      ></el-input>
      <!-- <span class="search-label">加入时间:</span>
      <el-date-picker
        v-model="searchForm.dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd"
        size="small"
        class="date-picker"
      ></el-date-picker> -->
      <el-button
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleSearch"
        >搜索</el-button
      >
      <el-button size="small" icon="el-icon-refresh" @click="handleReset"
        >重置</el-button
      >
    </div>
    <el-table :data="users" v-loading="loading" style="width: 100%">
      <el-table-column prop="phone" label="用户账户"></el-table-column>
      <el-table-column prop="withdrawable_balance" label="可提现/已提现金额">
        <template slot-scope="scope"
          ><div>
            ¥{{ fenToYuan(scope.row.withdrawable_balance) }} / ¥{{
              fenToYuan(scope.row.withdrawn_balance)
            }}
            <el-button type="text" @click="showWithdrawals(scope.row)"
              >查看记录</el-button
            >
          </div></template
        >
      </el-table-column>
      <el-table-column prop="invite_count" label="直邀人数"></el-table-column>
      <el-table-column prop="withdrawn_balance" label="有效/无效订单数">
        <template slot-scope="scope">
          <div>
            {{ scope.row.valid_order_count }}/{{
              scope.row.invalid_order_count
            }}
            <el-button type="text" @click="showOrders(scope.row)"
              >订单记录</el-button
            >
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column label="比例">
        <template slot-scope="scope">
          自得：{{ scope.row.distribution_self_ratio }}/ 上级：{{
            scope.row.distribution_parent_ratio
          }}/ 上上级：{{ scope.row.distribution_grandparent_ratio }}/ 虚提：{{
            scope.row.goods_boost_points
          }}%
        </template>
      </el-table-column> -->
      <el-table-column label="补贴比例">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.distribution_self_ratio*100 }}%</span>
            <el-button
              type="text"
              @click="
                distribution_self_ratio = scope.row.distribution_self_ratio*100;
                user_id = scope.row.id;
                showRatioDialog = true;
              "
              >修改</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="role" label="角色" width="200">
        <template slot-scope="scope">
          <el-tag :type="getRole(scope.row.role)">{{
            getRoleText(scope.row.role)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="is_enabled" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_enabled ? 'success' : 'danger'">{{
            scope.row.is_enabled ? "正常" : "禁用"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="注册时间"
        width="170"
      ></el-table-column>
      <el-table-column label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <template v-if="scope.row.role !== 'admin'">
            <!-- <el-button
              v-if="scope.row.is_enabled"
              type="danger"
              size="mini"
              @click="handleDisable(scope.row.id)"
              :loading="scope.row.loading"
            >
              禁用
            </el-button>
            <el-button
              v-else
              type="success"
              size="mini"
              @click="handleEnable(scope.row.id)"
              :loading="scope.row.loading"
            >
              启用
            </el-button> -->
            <el-button type="text" @click="saveLeader(scope.row.id)">{{
              scope.row.role == "user" ? "设为团长" : "取消团长"
            }}</el-button>
            <el-button type="text" @click="resetPassWord(scope.row)"
              >重置密码</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager" v-if="total > 0">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        @current-change="fetchUsers"
      />
    </div>

    <!-- 订单记录弹窗 -->
    <el-dialog
      :title="`用户${currentPhone}—订单记录`"
      :visible.sync="ordersDialogVisible"
      width="80%"
    >
      <el-table :data="orders" v-loading="ordersLoading" max-height="400">
        <el-table-column prop="id" label="订单号" width="300">
          <template slot-scope="{ row }">
            <div>订单编号：{{ row.id }}</div>
            <div>报单时间：{{ row.created_at }}</div>
            <div v-if="row.order">收货时间：{{ row.order.confirm_time }}</div>
            <div>
              跟单状态：
              <el-tag size="small" :type="getStatusType(row.bind_status)">
                {{ getStatusText(row.bind_status) }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" width="600">
          <template slot-scope="{ row }">
            <div v-if="row.order" class="goods-info">
              <el-image
                :src="row.order.item_img"
                class="goods-image"
                fit="cover"
              ></el-image>
              <div class="goods-title">
                <div class="title">{{ row.order.item_title }}</div>
                <div style="font-size: 12px">
                  订单状态：<el-tag
                    size="small"
                    :type="getOrderStatusType(row.order.flow_point)"
                  >
                    {{ getOrderStatusText(row.order.flow_point) }}
                  </el-tag>
                </div>
                <div style="font-size: 12px">
                  支付金额：
                  <span>¥{{ row.order.pay_price }}</span>
                </div>
                <span class="shop-name">店铺:{{ row.order.shop_name }}</span>
              </div>
            </div>
            <div v-else class="goods-info">
              <el-image class="goods-image" fit="cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i></div
              ></el-image>
              <div class="goods-title">
                <div>--</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="commission" label="总佣金">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.commission) }}</template
          >
        </el-table-column>
        <el-table-column prop="self_commission" label="用户佣金">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.self_commission) }}</template
          >
        </el-table-column>
        <el-table-column prop="parent_commission" label="上级佣金">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.parent_commission) }}</template
          >
        </el-table-column>
        <el-table-column prop="grandparent_commission" label="上上级佣金">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.grandparent_commission) }}</template
          >
        </el-table-column>
        <el-table-column prop="settle_status" label="结算状态" width="120">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.bind_status != 1"
              :type="getSettleType(scope.row)"
            >
              {{ getSettleText(scope.row) }}
            </el-tag>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager" v-if="ordersTotal > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="ordersTotal"
          :current-page="ordersPage"
          :page-size="ordersPageSize"
          @current-change="fetchOrders"
        />
      </div>
    </el-dialog>

    <!-- 提现记录弹窗 -->
    <el-dialog
      :title="`用户${currentPhone}—提现与收益记录`"
      :visible.sync="withdrawalsDialogVisible"
      width="60%"
    >
      <el-table
        :data="withdrawals"
        v-loading="withdrawalsLoading"
        max-height="400"
      >
        <el-table-column prop="created_at" label="时间"></el-table-column>
        <el-table-column prop="amount" label="提现金额">
          <template slot-scope="scope"
            >¥{{ fenToYuan(scope.row.amount) }}</template
          >
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.record_type === 'withdraw'"
              :type="getWithdrawStatusType(scope.row.status)"
            >
              {{ getWithdrawStatusText(scope.row.status) }}
            </el-tag>
            <el-tag v-else type="success"> 已结算 </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="alipay_account" label="支付宝账号">
          <template slot-scope="{ row }">
            {{
              row.alipay_account
                ? row.alipay_name + "(" + row.alipay_account + ")"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div class="pager" v-if="withdrawalsTotal > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="withdrawalsTotal"
          :current-page="withdrawalsPage"
          :page-size="withdrawalsPageSize"
          @current-change="fetchWithdrawals"
        />
      </div>
    </el-dialog>


    <el-dialog
      title="修改补贴比例"
      :visible.sync="showRatioDialog"
      width="300px"
    >
      <div>
        <div>
          <el-input
            v-model.number="distribution_self_ratio"
            type="number"
            :min="0"
            :max="100"
            placeholder="请输入数字"
          >
            <template slot="append">%</template>
          </el-input>
        </div>

        <div class="withdraw-tip">
          我的分成比例
          <span class="text-danger">{{ 100 - distribution_self_ratio }}</span
          >%
        </div>
      </div>

      <div slot="footer">
        <el-button @click="showRatioDialog = false">取消</el-button>
        <el-button type="primary" :loading="ratioLoading" @click="saveRatio"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import api from "../../api";

export default {
  name: "Users",
  data() {
    return {
      loading: false,
      users: [],
      total: 0,
      page: 1,
      pageSize: 10,
      keyword: "",

      // 订单记录弹窗
      ordersDialogVisible: false,
      ordersLoading: false,
      orders: [],
      ordersTotal: 0,
      ordersPage: 1,
      ordersPageSize: 20,
      currentUserId: "",
      currentPhone: null,

      // 提现记录弹窗
      withdrawalsDialogVisible: false,
      withdrawalsLoading: false,
      withdrawals: [],
      withdrawalsTotal: 0,
      withdrawalsPage: 1,
      withdrawalsPageSize: 20,
      showRatioDialog:false,
      distribution_self_ratio:0,
      ratioLoading:false
    };
  },
  created() {
    this.fetchUsers(1);
  },
  methods: {
    getRole(name) {
      const textMap = {
        user: "info",
        leader: "primary",
        admin: "danger",
      };
      return textMap[name] || "info";
    },
    getRoleText(name) {
      const textMap = {
        user: "普通用户",
        leader: "金牌团长",
        admin: "管理员",
      };
      return textMap[name] || "普通用户";
    },
    handleSearch() {
      this.fetchUsers(1);
    },
    handleReset() {
      this.keyword='';
      this.fetchUsers(1);
    },
    async fetchUsers(page) {
      this.page = page;
      this.loading = true;
      try {
        const params = {
          page,
          page_size: this.pageSize,
        };
        // 添加筛选参数
        if (this.keyword) {
          params.keyword = this.keyword;
        }
        const { data } = await api.get("/api/admin/users", {
          params,
        });
        this.users = data.items || [];
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error(e?.response?.data?.detail || "加载用户列表失败");
      } finally {
        this.loading = false;
      }
    },
    async showOrders(row) {
      this.currentUserId = row.id;
      this.currentPhone = row.phone;
      this.ordersDialogVisible = true;
      this.ordersPage = 1;
      this.fetchOrders(1);
    },
    async fetchOrders(page) {
      this.ordersPage = page;
      this.ordersLoading = true;
      try {
        const { data } = await api.get(
          `/api/admin/users/${this.currentUserId}/orders`,
          {
            params: { page, page_size: this.ordersPageSize },
          }
        );
        this.orders = data.items || [];
        this.ordersTotal = data.total || 0;
      } catch (e) {
        this.$message.error(e?.response?.data?.detail || "加载订单记录失败");
      } finally {
        this.ordersLoading = false;
      }
    },
    async showWithdrawals(row) {
      this.currentUserId = row.id;
      this.currentPhone = row.phone;
      this.withdrawalsDialogVisible = true;
      this.withdrawalsPage = 1;
      this.fetchWithdrawals(1);
    },
    async fetchWithdrawals(page) {
      this.withdrawalsPage = page;
      this.withdrawalsLoading = true;
      try {
        const { data } = await api.get(
          `/api/admin/users/${this.currentUserId}/withdrawals`,
          {
            params: { page, page_size: this.withdrawalsPageSize },
          }
        );
        this.withdrawals = data.items || [];
        this.withdrawalsTotal = data.total || 0;
      } catch (e) {
        this.$message.error(e?.response?.data?.detail || "加载提现记录失败");
      } finally {
        this.withdrawalsLoading = false;
      }
    },
    async saveLeader(user_id) {
      try {
        await api.put(`/api/admin/users/${user_id}/set-leader`);
        this.fetchUsers(this.page);
        this.$message.success("设置成功！");
      } catch (e) {
        this.$message.error("设置失败！");
      } finally {
      }
    },
    resetPassWord(data) {
      this.$confirm(`确定将【${data.phone}】的密码进行重置?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await api.put(`/api/admin/users/${data.id}/reset-password`);
            this.$message.success("重置成功！");
          } catch (e) {
            this.$message.error("重置失败！");
          } finally {
          }
        })
        .catch(() => {});
    },
    async saveRatio() {
      this.ratioLoading = true;
      try {
        await api.put(`/api/users/${this.user_id}/distribution-ratio`, {
          distribution_self_ratio: this.distribution_self_ratio,
        });
        this.showRatioDialog = false;
        this.fetchUsers(this.page)
        this.$message.success("保存成功");
      } catch (e) {
        this.$message.error(e?.userMessage || "保存失败");
      } finally {
        this.ratioLoading = false;
      }
    },
    fenToYuan(fen) {
      return (Number(fen || 0) / 100).toFixed(2);
    },
    getSettleType(data) {
      if (
        (data.settle_status == 1 || data.settle_status == 2) &&
        !data.is_commission_settled
      ) {
        return "primary";
      } else if (data.is_commission_settled) {
        return "success";
      } else if (data.settle_status == 3) {
        return "danger";
      } else {
        return "danger";
      }
    },
    getSettleText(data) {
      if (
        (data.settle_status == 1 ||
        data.settle_status == 2) && !data.is_commission_settled
      ) {
        return "待结算";
      } else if (data.is_commission_settled) {
        return "已结算";
      } else if (data.settle_status == 3) {
        return "不结算";
      } else {
        return "未知";
      }
    },
    getStatusType(status) {
      const statusMap = {
        1: "primary",
        2: "success",
        3: "danger",
      };
      return statusMap[status] || "primary";
    },
    getStatusText(status) {
      const textMap = {
        1: "查询中",
        2: "已跟单",
        3: "已丢单",
      };
      return textMap[status] || status || "未知";
    },
    getOrderStatusType(status) {
      const statusMap = {
        PAY_SUCC: "success",
        CONFIRM: "success",
        SETTLE: "success",
        REFUND: "danger",
      };
      return statusMap[status] || "primary";
    },
    getOrderStatusText(status) {
      const textMap = {
        PAY_SUCC: "已支付",
        CONFIRM: "已收货",
        SETTLE: "已收货",
        REFUND: "已退款",
      };
      return textMap[status] || status || "未知";
    },
    async handleEnable(userId) {
      const user = this.users.find((u) => u.id === userId);
      if (!user) return;
      user.loading = true;
      try {
        await api.post(`/api/users/${userId}/enable`);
        user.is_enabled = true;
        this.$message.success("已启用");
      } catch (e) {
        this.$message.error(e.userMessage || "启用失败");
      } finally {
        user.loading = false;
      }
    },
    getWithdrawStatusType(status) {
      const map = {
        pending: "warning", // 待处理 - 黄色
        completed: "success", // 已完结 - 绿色
        failed: "danger", // 失败 - 红色
        payback: "success", //打款失败，回退
      };
      return map[status] || "info";
    },
    getWithdrawStatusText(status) {
      const map = {
        pending: "审核中",
        completed: "已打款",
        failed: "提现失败",
        payback: "已退还",
      };
      return map[status] || status;
    },
    async handleDisable(userId) {
      const user = this.users.find((u) => u.id === userId);
      if (!user) return;
      user.loading = true;
      try {
        await api.post(`/api/users/${userId}/disable`);
        user.is_enabled = false;
        this.$message.success("已禁用");
      } catch (e) {
        this.$message.error(e.userMessage || "禁用失败");
      } finally {
        user.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page-hedaer {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title {
  margin: 0;
}
.title-info {
  color: #909399;
  margin-left: 5px;
  font-size: 12px;
}
.pager {
  margin-top: 20px;
  text-align: right;
}

.goods-image {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
}
.goods-info {
  display: flex;
  align-items: stretch;
}
.goods-title {
  padding: 0 10px;
}
.goods-title .title {
  height: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goods-image >>> .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 18px;
}

.title-info {
  margin-left: 5px;
  font-size: 12px;
  color: #909399;
}
.text-gray {
  color: #999;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-danger {
  color: #f56c6c;
}
.text-success {
  color: #67c23a;
}
.goods-image {
  width: 90px;
  height: 90px;
  flex-shrink: 0;
}
.goods-info {
  display: flex;
  align-items: stretch;
}
.goods-title {
  padding: 0 10px;
}
.goods-title .title {
  height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.goods-title .shop-name {
  display: block;
  color: #909399;
}
.search-bar {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  display: flex;
  align-items: center;
}
.search-input {
  width: 220px;
}
.search-select {
  width: 140px;
}
.date-picker {
  width: 260px;
}
</style>
